import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.report/reports", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.report/reports", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function byDashboardId(dashboardId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/byDashboard/${dashboardId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function byWidgetId(dashboardId, widgetId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/byWidget/${dashboardId}/${widgetId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function byWidgetIds(dashboardId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.report/reports/byWidgets/${dashboardId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function reports(sort = "title", page = 1, per_page = 50, order = "asc", query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.report/reports/paginated", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function adhocReportValues(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.report/reports/values", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(reportId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(reportId, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.report/reports/${reportId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(reportId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.report/reports/${reportId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateDelivery(reportId, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.report/reports/${reportId}/delivery`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function downloadNow(reportId, filename, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.report/reports/${reportId}/downloadNow/${filename}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function sendReport(reportId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/email`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function generateReport(reportId, filename, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/generate/${filename}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getLogo(reportId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/logo`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updatePositions(reportId, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.report/reports/${reportId}/positions`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getShort(reportId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/short`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSummary(reportId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.report/reports/${reportId}/summary`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function reportValues(reportId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.report/reports/${reportId}/values`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
